import React, {
  useState, Fragment, useEffect, useMemo,
} from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Tabs } from 'antd';
import DepartmentActions from '@Actions/departmentActions';
import WorkflowList from '@Components/Settings/Workflow/WorklowList';
import './style.scss';
import documentUINamesConstant from '../../../apis/documentUINamesConstant';

const { TabPane } = Tabs;

/**
 *
 */
const Workflow = ({
  showCart, user, location, getDepartments, history,
}) => {
  const [currentTab, setCurrentTab] = useState('/workflow-purchase-request');

  useEffect(() => {
    getDepartments('', user?.tenant_info?.tenant_id, 1, 1000);
  }, []);

  useEffect(() => {
    const key = new URLSearchParams(location.search).get('key');
    setCurrentTab(key || '/workflow-purchase-request');
  }, [currentTab]);

  const onTabChange = (key) => {
    setCurrentTab(key);
    history.push(`?key=${key}`);
  };

  const documentUINames = useMemo(() => documentUINamesConstant(user), [user]);

  return (
    <Fragment>
      <div className="ant-row">
        <div className={showCart ? 'ant-col-md-17' : 'ant-col-md-24'}>
          <div className="org-workflow__outer-wrapper doc-list__tabs-wrapper">
            <Tabs activeKey={currentTab?.toString()} onChange={(value) => onTabChange(value)}>
              <TabPane tab="Material Request" key="/workflow-purchase-request" />
              <TabPane tab="Purchase Indent" key="/workflow-purchase-indent" />
              <TabPane tab="Purchase Order" key="/workflow-purchase-order" />
              <TabPane tab="Outgoing Payment" key="/workflow-outgoing-payment" />
              <TabPane tab={documentUINames.estimateUIName} key="/workflow-estimate" />
              <TabPane tab={documentUINames.salesOrderUIName} key="/workflow-sales-order" />
              <TabPane tab="Packing Slip" key="/workflow-packing-slip" />
              <TabPane tab="Invoice" key="/workflow-invoice" />
              <TabPane tab="Stock Adjustment" key="/workflow-stock-adjustment" />
              <TabPane tab="Stock Transfer" key="/workflow-stock-transfer" />
              <TabPane tab="Goods Receiving" key="/workflow-goods-receiving" />
              <TabPane tab="Account Payable Invoice" key="/workflow-account-payable-invoice" />
              <TabPane tab="Annual Maintenance Contract" key="/workflow-annual-maintenance-contract" />
              {/* <TabPane tab="Delivery Challan" key="/workflow-delivery-challan" /> */}

            </Tabs>
            {currentTab === '/workflow-purchase-request' && <WorkflowList workflowType="PURCHASE_REQUISITION" />}
            {currentTab === '/workflow-purchase-indent' && <WorkflowList workflowType="PURCHASE_INDENT" />}
            {currentTab === '/workflow-purchase-order' && <WorkflowList workflowType="PURCHASE_ORDER" />}
            {currentTab === '/workflow-outgoing-payment' && <WorkflowList onlyStore workflowType="VENDOR_PAYOUT" />}
            {currentTab === '/workflow-estimate' && <WorkflowList workflowType="SALES_ESTIMATE" />}
            {currentTab === '/workflow-sales-order' && <WorkflowList workflowType="SALES_ORDER" />}
            {currentTab === '/workflow-packing-slip' && <WorkflowList workflowType="PACKING_SLIP" />}
            {currentTab === '/workflow-invoice' && <WorkflowList workflowType="INVOICE" />}
            {currentTab === '/workflow-stock-adjustment' && <WorkflowList workflowType="STOCK_ADJUSTMENT" />}
            {currentTab === '/workflow-stock-transfer' && <WorkflowList workflowType="STOCK_TRANSFER" />}
            {currentTab === '/workflow-goods-receiving' && <WorkflowList workflowType="GOOD_RECEIVING_NOTE" />}
            {currentTab === '/workflow-delivery-challan' && <WorkflowList workflowType="DELIVERY_CHALLAN" />}
            {currentTab === '/workflow-account-payable-invoice' && <WorkflowList workflowType="ACCOUNT_PAYABLE_INVOICE" />}
            {currentTab === '/workflow-annual-maintenance-contract' && <WorkflowList workflowType="ANNUAL_MAINTENANCE_CONTRACT" />}
          </div>
        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = ({
  UserReducers, WorkflowsReducers, DepartmentReducers,
}) => ({
  user: UserReducers.user,
  purchaseWorkflows: WorkflowsReducers.purchaseWorkflows,
  getPurchaseWorkflowsLoading: WorkflowsReducers.getPurchaseWorkflowsLoading,
  getDepartmentsLoading: DepartmentReducers.getDepartmentsLoading,
  departments: DepartmentReducers.departments,
});

const mapDispatchToProps = (dispatch) => ({
  getDepartments: (keyword, tenantId, page, limit, departmentId, callback) => dispatch(DepartmentActions.getDepartments(keyword, tenantId, page, limit, departmentId, callback)),
});

Workflow.propTypes = {
  showCart: PropTypes.func,
  history: PropTypes.func,
  getDepartments: PropTypes.func,
  user: PropTypes.any,
  location: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Workflow));
